export const userRoleConstant = {
  User: { name: 'User', value: 'USR' },
  Admin: { name: 'Admin', value: 'ADM' }
}

export const trialStatusConstant = {
  Draft: { name: 'Draft', value: 'DFT' },
  Assigned: { name: 'Assigned', value: 'ASS' },
  Submitted: { name: 'Submitted', value: 'SUB' },
  Closed: { name: 'Closed', value: 'CLS' },
  Archived: { name: 'Archived', value: 'ARC' }
}
